import get from 'lodash/get';
export var resolveErrorResponseDescription = function resolveErrorResponseDescription(errorResponse) {
  if (errorResponse.getStatus() === 500) {
    return null;
  }

  return get(errorResponse.getData(), 'error_description', null);
};